import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";
import {getIndividualLabel} from "../utils/bo-show-utils.js";
import BoShowAttachmentGallery from "./bo-show-attachment-gallery.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const BoShowVehicles = () => {
    const {boData, verifySyncUrl} = useContext(BoShowContext);
    const vehicleList = boData?.vehicleList;

    const navigate = navigateHook();

    if (!vehicleList?.length) return null;

    return (
        <>
            {
                vehicleList.map((vehicle, index) => {
                    const apprehension = boData?.apprehensionList?.find((item) => item?.relatedVehicle === vehicle?.itemId);
                    const vehiclePhotos = vehicle?.attachs?.filter((attach) => attach?.attachId !== vehicle?.documentPhotoId) ?? [];
                    const vehicleDocument = vehicle?.attachs?.find((attach) => attach?.attachId === vehicle?.documentPhotoId);

                    return (
                        <article key={vehicle?.itemId ?? index} className={"space-y-4"}>
                            <h2 className={"resume-title flex gap-2 justify-center items-center"}>
                                VEÍCULO  - {index + 1} {apprehension ? "(APREENDIDO)" : ""}
                                {
                                    vehicle.plate &&
                                    <span className={"cursor-pointer print:hidden"} onClick={() => navigate(`/vehicle/form/${vehicle.plate}`, true)}>
                                        <FaExternalLinkAlt size={14}/>
                                    </span>
                                }
                            </h2>

                            <section className={"grid grid-cols-3 gap-2"}>
                                <p className={"col-span-3"}>Indivíduo: <span className={"info"}>{getIndividualLabel(boData?.individualList, vehicle?.relatedPerson)}</span></p>
                                <p>Placa: <span className={"info !font-bold"}>{vehicle?.plate ? platePatternUtils.formatPlate(vehicle.plate) : ""}</span></p>
                                <p>Município da placa: <span className={"info"}>{vehicle?.city ?? ""}</span></p>
                                <p>RENAVAM: <span className={"info"}>{vehicle?.renavam ?? ""}</span></p>
                                <p className={"col-span-3"}>Marca/Modelo: <span className={"info"}>{vehicle?.brandModel ?? ""}</span></p>
                                <p className={"col-span-2"}>Tipo (Denatram): <span className={"info"}>{vehicle?.type ?? ""}</span></p>
                                <p>Chassi: <span className={"info"}>{vehicle?.chassis ?? ""}</span></p>
                                <p>Ano de fabricação: <span className={"info"}>{vehicle?.fabricationYear ?? ""}</span></p>
                                <p>Ano do modelo: <span className={"info"}>{vehicle?.modelYear ?? ""}</span></p>
                                <p>Cor: <span className={"info"}>{vehicle?.color ?? ""}</span></p>
                                <p>Recuperado: <span className={"info"}>{vehicle?.recovered !== undefined ? (vehicle.recovered ? "Sim" : "Não") : ""}</span></p>
                                <p className={"col-span-2"}>Removido: <span className={"info"}>{vehicle?.removed !== undefined ? (vehicle.removed ? "Sim" : "Não") : ""}</span></p>
                            </section>

                            <section className={"space-y-2"}>
                                <h3 className={"!font-normal"}>Observação</h3>
                                <p className={"info whitespace-pre-wrap"}>{vehicle?.observation ?? ""}</p>
                            </section>

                            {
                                apprehension &&
                                <section className={"space-y-2"}>
                                    <h3 className={"!font-normal"}>Apreensão</h3>

                                    <div className={"grid grid-cols-3 gap-2"}>
                                        <p>Destino: <span className={"info"}>{apprehension?.destination ?? ""}</span></p>
                                        <p>Recebedor: <span className={"info"}>{apprehension?.receiver ?? ""}</span></p>
                                        <p>Descrição: <span className={"info"}>{apprehension?.description ?? ""}</span></p>
                                    </div>
                                </section>
                            }

                            {
                                vehicleDocument &&
                                <section className={"space-y-2"}>
                                    <h3 className={"!font-normal"}>Documento</h3>
                                    <BoShowAttachmentGallery
                                        attachments={vehicleDocument ? [vehicleDocument] : []}
                                        verifySyncUrl={verifySyncUrl}
                                        titleMaker={() => `VEÍCULO - ${index + 1} - Documento`}
                                        descriptionField={false}
                                    />
                                </section>
                            }

                            {
                                !!vehiclePhotos.length &&
                                <section className={"space-y-2"}>
                                    <h3 className={"!font-normal"}>Fotos do veículo</h3>
                                    <BoShowAttachmentGallery
                                        attachments={vehiclePhotos}
                                        verifySyncUrl={verifySyncUrl}
                                        titleMaker={(_, attachmentIndex) => `VEÍCULO - ${attachmentIndex + 1} - Foto do veículo`}
                                        descriptionField={false}
                                    />
                                </section>
                            }
                        </article>
                    );
                })
            }
        </>
    );
};

export default BoShowVehicles;
